import { gql } from '@apollo/client'

export const FETCH_EHR_SUGGESTED_AVAILABILITY = gql`
  query ehrSuggestedAvailability(
    $excludedProvidersHealthieIds: [ID!]
    $appointmentKind: EhrAppointmentKind
  ) {
    ehrSuggestedAvailability(
      excludedProvidersHealthieIds: $excludedProvidersHealthieIds
      appointmentKind: $appointmentKind
    ) {
      meetingAt
      providerId
      providerName
      title
      appointmentKind
      providerProfile {
        id
        coachId
        fullName
        bio
        photo
        credentials
        specialties {
          key
          name
        }
      }
    }
  }
`
